import { render } from "./confirmPayDiy.vue?vue&type=template&id=46fb2893&scoped=true"
import script from "./confirmPayDiy.vue?vue&type=script&lang=js"
export * from "./confirmPayDiy.vue?vue&type=script&lang=js"

import "./confirmPayDiy.vue?vue&type=style&index=0&id=46fb2893&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fb2893"]])

export default __exports__